/* eslint-disable import/no-default-export */
import classNames from 'classnames';
// eslint-disable-next-line no-restricted-imports
import { Icon, IconName } from 'common/components/controls';
// eslint-disable-next-line no-restricted-imports
import { CloseButton } from 'components/buttons';
// eslint-disable-next-line no-restricted-imports
import buttonStyles from 'components/shared/button.less';
// eslint-disable-next-line no-restricted-imports
import { closePopover, PopoverName, State } from 'modules';
import React from 'react';
import { connect } from 'react-redux';
import { Dispatch } from 'redux';

import { PopoverTestIds } from '@trello/webdriverio-tests';
import styles from './popover-header.less';

interface DispatchProps {
  onClose: React.EventHandler<React.MouseEvent<HTMLButtonElement>>;
}

interface PopoverHeaderProps {
  popoverName: PopoverName;
  onClickBack?:
    | (() => void)
    | React.EventHandler<React.MouseEvent<HTMLButtonElement>>;
  showCloseButton?: boolean;
  title?: React.ReactNode;
}

export class PopoverHeaderUnconnected extends React.Component<
  DispatchProps & PopoverHeaderProps
> {
  render() {
    const { onClose, onClickBack, showCloseButton, title } = this.props;

    return (
      <div className={styles.header}>
        {onClickBack ? (
          <button
            className={classNames(buttonStyles.buttonLink, styles.headerBack)}
            onClick={onClickBack}
          >
            <Icon name={IconName.Back} small />
          </button>
        ) : null}
        {/* tslint:disable-next-line:react-no-dangerous-html */}
        {title && <span className={styles.headerTitle}>{title}</span>}

        {(title || showCloseButton) && (
          <CloseButton
            className={styles.headerClose}
            onClick={onClose}
            testId={PopoverTestIds.ClosePopover}
            small
          />
        )}
      </div>
    );
  }
}

const mapDispatchToProps = (
  dispatch: Dispatch<State>,
  ownProps: PopoverHeaderProps,
) => {
  return {
    onClose(e: React.MouseEvent<HTMLElement>) {
      // This is here to prevent any parent popovers
      // from closing in the case of a nested popover
      e.preventDefault();
      e.stopPropagation();
      dispatch(closePopover(ownProps.popoverName));
    },
  };
};

export default connect(
  undefined,
  mapDispatchToProps,
)(PopoverHeaderUnconnected);



// WEBPACK FOOTER //
// ./app/gamma/src/components/popover/popover-header.tsx